// extracted by mini-css-extract-plugin
module.exports = {"EditSettings":"EditSettings_EditSettings__/9j9k"};